import React from 'react';
import PropTypes from 'prop-types';

const EntryPhotos = (props) => {
  const imgElementForPhoto = (photo) => {
    return <img alt={`Entry P#${photo.id}`} src={photo.defaultImage.href} height={photo.defaultImage.height} width={photo.defaultImage.width} />;
  }

  // HACK: just showing off the first photo for now
  const firstPhoto = props.photos[0];
  return imgElementForPhoto(firstPhoto);
}

EntryPhotos.propTypes = {
  photos: PropTypes.array.isRequired
};

export default EntryPhotos;


// WEBPACK FOOTER //
// ./src/views/entryPhotos.js